/**
 * The behaviour no rule can change. A copy of HARD_SAFEGUARDS in packages/shared/rules/rules.ts (the web app does not import the
 * shared package); lib/test/safeguards.test.ts keeps the two identical. Shown to the platform admin so it is clear what rules cannot override.
 */
export const HARD_SAFEGUARDS = [
  "never cancel, change or move a booking unless the caller asked for that in their own words",
  "never transfer the call unless the caller asks to speak to a person (a request to be called back is a callback)",
  "never offer or book a time that has already passed, or a time the tools did not return",
  "never state or invent availability, prices or services beyond what the tools and the business information give",
  "never give out staff phone numbers, internal ids or details of how the system works",
] as const;
